import React from "react";
import fingerprint from "../assets/romania_fingerprint.svg";
import { FOOTER } from "../mock/mock";

export default function Footer() {
  return (
    <footer className="theme-light border-t border-[var(--pl-line)] bg-[var(--pl-bg)] px-6 py-20 text-[var(--pl-text)] md:px-10 lg:px-16">
      <div className="mb-14 flex flex-col items-start gap-3 select-none">
        <div className="font-display font-black uppercase text-[clamp(2.25rem,7.2vw,5.9rem)] leading-none tracking-[-0.03em] text-[var(--pl-text)]">
          PLANIMEX
        </div>
        <div className="flex items-center gap-3">
          <img
            src={fingerprint}
            alt="Romania fingerprint"
            className="h-[clamp(2.4rem,7.5vw,5.8rem)] w-auto bg-transparent object-contain"
          />
          <span className="text-sm font-medium uppercase tracking-[0.24em] text-[var(--pl-text-2)]">
            Made in Romania
          </span>
        </div>
      </div>
      <div className="border-t border-[var(--pl-line)] pt-8">
        <span className="mono-label whitespace-nowrap text-[clamp(0.58rem,2.2vw,0.69rem)] text-[var(--pl-text-2)]">{FOOTER.copyright}</span>
      </div>
    </footer>
  );
}
